<template>
  <div class="steps-nav">
    <button
      class="nav-btn nav-btn--ghost"
      type="button"
      @click="$emit('cancel')"
    >
      {{ cancelButtonLabel }}
    </button>

    <button
      class="nav-btn nav-btn--primary"
      type="button"
      :disabled="!canProceed"
      @click="$emit('next')"
    >
      {{ nextButtonLabel }}
    </button>
  </div>
</template>

<script>
export default {
  name: "StepsNav",
  props: {
    cancelButtonLabel: {
      type: String,
      default: "",
    },
    nextButtonLabel: {
      type: String,
      default: "",
    },
    canProceed: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped lang="scss">
.steps-nav {
  position: sticky;
  bottom: 0;
  z-index: 5;
  display: flex;
  gap: 16px;
  justify-content: center;
  padding: 18px 24px 24px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #ffffff 32%);
}

.nav-btn {
  min-width: 220px;
  height: 48px;
  border-radius: 16px;
  font-size: 14px;
  font-weight: 700;
  transition: all 0.2s ease;
}

.nav-btn--ghost {
  border: 1px solid rgba(15, 23, 42, 0.12);
  color: #475569;
  background: #fff;
}

.nav-btn--ghost:hover {
  border-color: rgba(15, 23, 42, 0.24);
  background: #f8fafc;
}

.nav-btn--primary {
  border: none;
  color: #fff;
  background: var(--main-color);
  box-shadow: 0 16px 32px rgba(15, 23, 42, 0.16);
}

.nav-btn--primary:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 18px 36px rgba(15, 23, 42, 0.2);
}

.nav-btn--primary:disabled {
  cursor: not-allowed;
  opacity: 0.45;
  box-shadow: none;
}

@media (max-width: 700px) {
  .steps-nav {
    gap: 12px;
    padding: 16px;
  }

  .nav-btn {
    min-width: 0;
    width: 100%;
  }
}
</style>
